import React, { Component } from 'react';
import ContentWrapper from '../../components/Layout/ContentWrapper';
import {SkyLightStateless} from 'react-skylight';
import ReactDataGrid from 'react-data-grid';
import { Toolbar, Data } from 'react-data-grid-addons';
import { Field } from 'redux-form';
import { Grid, Button, ButtonToolbar, Row } from 'react-bootstrap';
import Spinner from '../Widgets/spinner';
import { UI_HEIGHT } from '../Common/constants';
import { Translate, Localize } from 'react-redux-i18n';

class ChartModal extends Component {
  static contextTypes = {
      router: React.PropTypes.object
  };
  constructor() {
    super();
    this.state = {
      charts: {
        rows: [],
        selectedRows: [],
        sortColumn: null,
        sortDirection: null,
      },
      isToday: true,
    }
  }

  componentDidMount() {
    const changeDateFormat = (day)=>{
      let y = day.getFullYear().toString();
      let m = day.getMonth()+1;
      if(m < 10) {
        m = '0'+m;
      }
      else {
        m = m.toString();
      }
      let d = day.getDate();
      if(d < 10) {
        d = '0'+d;
      }
      else {
        d = d.toString();
      }
      d = y + m + d;
      return d;
    }
    let date = changeDateFormat(new Date());
    let isToday = false;
    if(date == this.props.date)
      isToday = true;
    this.setState({isToday: isToday})
  }

  componentWillReceiveProps(nextProps) {
    if(nextProps.purchasePivotCharts && nextProps.purchasePivotCharts != this.props.purchasePivotCharts) {
      let charts = {...this.state.charts, rows: nextProps.purchasePivotCharts}
      this.setState({charts});
    }
  }

  renderChartTable() {
    if (this.props.purchasePivotChartOrdersIsLoading && !this.props.purchasePivotChartOrdersError) return <Spinner/>
    else if (this.props.purchasePivotChartOrdersError) return <ContentWrapper><div className="alert alert-danger">{JSON.stringify(this.props.purchasePivotChartOrdersError)}</div></ContentWrapper>
    else {
      const getRows = () => {
          return Data.Selectors.getRows(this.state.charts);
      }

      const getSize = () => {
          return getRows().length;
      }

      const rowGetter = rowIdx => {
          var rows = getRows();
          return Object.assign({}, rows[rowIdx]);
      }

      const handleGridSort = (sortColumn, sortDirection) => {
          var state = Object.assign({}, this.state.charts, { sortColumn: sortColumn, sortDirection: sortDirection });
          this.setState({charts: state});
      }

      const onRowsSelected = (rows) => {
           let newRows = getRows();
           let selectedRows = [newRows[rows[0].rowIdx]];
           newRows.map (r => {
             r.isSelected = false;
           });
           newRows[rows[0].rowIdx].isSelected = true;
           let charts = {...this.state.charts, rows: newRows, selectedRows: selectedRows}
           this.setState({charts});
      }

       const onRowsDeselected = (rows) => {
           let newRows = getRows();
           rows.map (r => {
             newRows[r.rowIdx].isSelected = false;
           });
           let charts = {...this.state.charts, rows: newRows, selectedRows: []}
           this.setState({charts});
       }
       const columns = [
         {
             key: 'id',
             name: <Translate value="idx" />,
             resizable: true,
             sortable: true,
             width: 100,
             filterable: true
         },
         {
             key: 'Name',
             name: <Translate value="name" />,
             resizable: true,
             sortable: true,
             filterable: true
         },
         {
             key: 'Description',
             name: <Translate value="description" />,
             resizable: true,
             sortable: true,
             filterable: true
         },
      ]
      return (
        <div className="react-table-customizer" id="ChartModal-dataGrid1">
          <ReactDataGrid
              rowKey='Product_id'
              enableCellSelect={true}
              onGridSort={handleGridSort}
              columns={columns}
              rowHeight={25}
              minHeight={480}
              rowGetter={rowGetter}
              rowsCount={getSize()}
              rowSelection={{
                showCheckbox: true,
                onRowsSelected: onRowsSelected,
                onRowsDeselected: onRowsDeselected,
                selectBy: {
                  isSelectedKey: 'isSelected'
                }
              }}
          />
        </div>
      )
    }
  }

  render() {
    return (
      <ContentWrapper>
        <Grid id="chart-modal">
          <ButtonToolbar>
            <Button
              bsStyle="success"
              type="submit"
              disabled={!this.state.isToday}
              onClick={()=>{this.props.setPurchasePivotChart(null); this.context.router.push('/purchasePivotChart/new')}}>
              <em className="fa fa-plus" />
              <Translate value="add" />
            </Button>
            <Button
              bsStyle="warning"
              type="button"
              onClick={()=>{this.props.setPurchasePivotChart(this.state.charts.selectedRows[0].PurchasePivot_id); this.context.router.push('/purchasePivotChart/'+ this.state.charts.selectedRows[0].PurchasePivot_id)}}
              disabled={!this.state.charts.selectedRows || this.state.charts.selectedRows.length != 1}>
              <em className="fa fa-pencil" />
              <Translate value="edit" />
            </Button>
            <Button
              bsStyle="success"
              type="button"
              disabled={this.state.isToday || !this.state.charts.selectedRows || this.state.charts.selectedRows.length != 1}
              onClick={()=>{this.props.duplicatePivotChart(this.state.charts.selectedRows[0].PurchasePivot_id)}}>
              <em className="fa fa-pencil" /><Translate value="duplicate" />
            </Button>
          </ButtonToolbar>
          <div className="width">
            {this.renderChartTable()}
          </div>
          { (this.props.isDuplicatingPurchasePivotChart) && <div><Spinner/></div> }
          { (this.props.duplicatedPurchasePivotChart) && <div className='alert alert-success'><Translate value="saved" /></div> }
        </Grid>
      </ContentWrapper>
    )
  }
}

export default ChartModal;



// WEBPACK FOOTER //
// ./master/jsx/components/Purchase/chartModal.jsx